import { useAuthStore } from './stores/auth'
import { useSystemStore } from './stores/system'

export default {
  install: (app) => {
    app.config.globalProperties.$can = function (permissions) {
      const authStore = useAuthStore()
      if (!authStore.authUser || !authStore.selectedOffice) {
        return false
      }

      if (!Array.isArray(permissions)) {
        permissions = [permissions]
      }

      for (let i = 0; i < permissions.length; i++) {
        if (
          !authStore.authUser.all_permissions_list.includes(permissions[i]) &&
          !authStore.selectedOffice.permissions_list.includes(permissions[i])
        ) {
          return false
        }
      }

      return true
    }
    app.config.globalProperties.$cannot = function (permissions) {
      return !app.config.globalProperties.$can(permissions)
    }
    app.config.globalProperties.$adminCanManage = function (countryList) {
      const systemStore = useSystemStore()
      const authStore = useAuthStore()

      return (
        app.config.globalProperties.$can('access members hub admin') &&
        (!systemStore.hub.country_filters_enabled ||
          (systemStore.hub.country_filters_enabled &&
            (authStore.authAssignedCountries.length === 0 ||
              countryList.filter((c) => authStore.authAssignedCountries.includes(c)).length > 0)))
      )
    }
  }
}
